module.exports = __webpack_public_path__ + "static/media/pot.548824cf.png";